const LandingPageButton = ( {children, onClick, additionalclasses} ) => {
    return (
        <div onClick={onClick} className={`cursor-pointer bg-white text-grey-900 w-fit m-auto px-[44px] h-[49px] grid items-center font-regular text-[16px] poppins-medium leading-[26px] rounded-[8px] rounded-[12px] ${additionalclasses}`}>
            {children}
        </div>
    )
}
export default LandingPageButton;